import { ulid } from '@w/utils'
import type { Block } from '@w/content-blocks/src/block'

/** Distinct question identities anywhere in a document, including nested fields. */
export function questionIds(value: unknown, ids = new Set<string>()): Set<string> {
  if (!value || typeof value !== 'object') return ids
  if ('qid' in value && typeof value.qid === 'string') ids.add(value.qid)
  for (const item of Object.values(value)) questionIds(item, ids)
  return ids
}

/** Clear block ids; remap each copied question once across all of its parts. */
export function unsavedCopy(block: Block, qids = new Map<string, string>(), live?: ReadonlySet<string>): Block {
  return resetCopyIds(structuredClone(block), qids, live)
}

/** Newly parsed trees are exclusively owned: reset their identities without copying them first. */
export function resetCopyIds(block: Block, qids = new Map<string, string>(), live?: ReadonlySet<string>): Block {
  const mint = (value: unknown): void => {
    if (!value || typeof value !== 'object') return
    if ('type' in value && 'id' in value) value.id = ''
    if ('qid' in value && typeof value.qid === 'string' && (!live || live.has(value.qid))) {
      const old = value.qid
      if (!qids.has(old)) qids.set(old, ulid())
      value.qid = qids.get(old)
    }
    for (const item of Object.values(value)) mint(item)
  }
  mint(block)
  return block
}
